var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightSolder = function SvgRightSolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 71 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CBF8ED",
    d: "M0 7.325v34.5h45c1-1.833 4.5-7.174 11.5-10.5s11.833-6 13.5-6.5c.333-2 .8-7.3 0-12.5-1-6.5-5-8.5-13.5-11.5-6.8-2.4-18.833 1-24 3H23c-13 0-23 3.5-23 3.5"
  })));
};
export default SvgRightSolder;